import React from 'react'
import {Pagination} from "antd";
import useBreakpoint from "antd/es/grid/hooks/useBreakpoint";

export default (props) => {
    const {xs} = useBreakpoint();

    return (
        <Pagination
            {...props}
            size={xs ? 'small' : 'default'}
        />
    )
}